<template>
    <div>
        <Navbar class="bg-white" />
        <PageTitle pageTitle="Lane Wise" />
        <LaneWiseDetails />
        <Newsletter />
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layout/Navbar'
import PageTitle from '../Common/PageTitle'
import LaneWiseDetails from '../SingleProjects/LaneWiseDetails'
import Newsletter from '../Common/Newsletter'
import Footer from '../Layout/Footer'

export default {
    name: 'SmartGlass',
    components: {
        Navbar,
        PageTitle,
        LaneWiseDetails,
        Newsletter,
        Footer,
    }
}
</script>